import blog1 from "../assets/images/blog1.svg";
import blog2 from "../assets/images/blog2.svg";
import blog3 from "../assets/images/blog5.svg";
import blog4 from "../assets/images/blog3.svg";
import blog5 from "../assets/images/blog4.svg";

const blogs = [
    {
        id: 1,
        title: 'React Hooks',
        date: '01',
        month: 'April',
        image: blog1
    },
    {
        id: 2,
        title: 'Functional Components React',
        date: '01',
        month: 'April',
        image: blog2
    },
    {
        id: 3,
        title: 'How to choose a programming Language',
        date: '01',
        month: 'April',
        image: blog3,
        link: 'https://www.google.co.uk/'
    },
    {
        id: 4,
        title: 'How To Use SEO Efficiently',
        date: '01',
        month: 'April',
        image: blog4
    },
    {
        id: 5,
        title: 'Lorem Ipsum ui erw pi',
        date: '01',
        month: 'April',
        image: blog5
    },

]

export default blogs;